import {
    Platform
} from "react-native";
import type {
    RefreshTokenResponseType
} from "./types";
import axios from "axios";
import {
    storage
} from "../../../../storage";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const RefreshToken = async (): Promise<RefreshTokenResponseType> => {
    const refreshToken = storage.getString("refreshToken");

    return await axios(`${SERVER_ADDRESS}/authentication/refreshToken`, {
        method: "POST",
        headers: getHeaders(),
        data: JSON.stringify({
            token: refreshToken,
            device: Platform.OS === "android" ? "android" : Platform.OS === "ios" ? "ios" : "web"
        })
    })
        .then((res) => {
            if(
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                storage.set("accessToken", res.data.payload.accessToken);
                storage.set("refreshToken", res.data.payload.refreshToken);

                return res.data;
            }
            throw res;
        })
        .catch((err) => {
            throw err;
        });
};
export default RefreshToken;
